import { floatMul } from "@/util/util";


export function quotaListConfig(getMoney, selectPersonClick, selectDeptClick) {
  return {
    menuType: "button",
    addBtn: false,
    menuWidth: 120,
    menuAlign: "center",
    card: true,
    menu: false,
    delBtn: false,
    editBtn: false,
    align: "center",
    searchMenuSpan: 8,
    columnBtn: false,
    searchBtn: true,
    searchShow:false,
    // index: true,
    // indexLabel: "序号",
    refreshBtn: true,
    selection: true,
    selectionWidth: 45,
    column: [{
        label: "编号",
        prop: "id",
        overHidden: true,
        display: false,
        width: 150,
      },
      {
        label: "方案名称",
        searchPlaceholder: "请输入方案名称/编号",
        search: true,
        slot: true,
        prop: "name",
        overHidden: true,
        display: false,
        width: 300,
      },
      {
        label: "关联的项目",
        prop: "projectName",
        slot: true,
        overHidden: true,
        display: false,
        width: 300,
        align: 'left'
      },

      // {
      //   label: "业务类型",
      //   prop: "bizType",
      //   type: "select",
      //   search: true,
      //   dicUrl: "/api/blade-system/dict-biz/dictionary?code=biz_type",
      //   props: {
      //     label: "dictValue",
      //     value: "dictKey",
      //   },
      //   display: false,
      //   overHidden: true,
      //   hide: true,
      // },
      {

        label: "客户名称",
        placeholder: "请输入客户名称",
        search: true,
        prop: "custName",
        overHidden: true,
        display: false,
        width: 200,

      },
      {
        label: "融资额度（元）",
        prop: "quotationPrice",
        width: "150",
        sortable: true,
        overHidden: true,
        formatter: (row, value, label, column) => {
          return `${getMoney(Number(value).toFixed(2))}`;
        },

      },
      {
        label: "还款期限(日)",
        prop: "leaseTerm",
        width: "150",

        overHidden: true,

      },
      // {
      //   label: "租金还款频次",
      //   prop: "repaymentFrequency",
      //   type: "select",
      //   dicUrl: "/api/blade-system/dict-biz/dictionary?code=repayment_frequency",
      //   props: {
      //     label: "dictValue",
      //     value: "dictKey",
      //   },
      //   dataType: "number",
      //   width: 200,
      //   display: false,
      //   overHidden: true,

      // },
      {
        label: "XIRR(%）",
        prop: "xirr",
        width: "150",
        formatter: (row, value, label, column) => {
          return Number(floatMul(value,100)).toFixed(4)
        },
        overHidden: true,

      },
      {
        label: "首付款使用费率(%）",
        prop: "annualInterestRate",
        width: "150",
        formatter: (row, value, label, column) => {
          return Number(floatMul(value , 100))
        },
        overHidden: true,

      },
      {
        label: "创建时间",
        type: "daterange",
        placeholder: "请选择时间",
        prop: "createTime",
        overHidden: true,
        width: "150"
      }

    ]
  }
}

export function filterConfig(selectPersonClick, selectDeptClick) {
  return {
    column: [{
        label: "客户名称",
        placeholder: "请输入客户名称",
        prop: "sellerCustName"
      }, {
        label: "融资额度",
        placeholder: "请输入客户名称",
        prop: "factoringCredit",
        formslot: true
      }, {
        label: "业务经理",
        placeholder: "请选择业务经理",
        width: "120",
        prop: "managerUserName",
        click: () => {
          selectPersonClick();
        }
      }, {
        label: "所属部门",
        placeholder: "请选择部门",
        prop: "managerDeptName",
        width: "150",
        click: () => {
          selectDeptClick();
        }
      }, {
        label: "更新时间",
        type: "daterange",
        placeholder: "请选择时间",
        prop: "updateTimeRange",
        overHidden: true,
        width: "150"
      }, {
        label: "状态",
        type: "select",
        prop: "quotaStatus",
        dicData: [{
            value: 0,
            name: "失效"
          },
          {
            value: 1,
            name: "生效"
          }
        ]
      }

    ]
  }
}

export function basicConfig(selectDeptClick, selectPersonClick) {
  return {
    labelWidth: 130,
    emptyBtn: false,
    submitBtn: false,
    column: [



      // {
      //   label: "方案模板",
      //   placeholder: "请选择方案模板",
      //   formslot: true,
      //   prop: "nameTemplate",
      //   overHidden: true,
      //   display: true,
      //   span: 22,
      // },
      // {
      //   label: "计算类型",
      //   prop: "countType",
      //   type: "select",
      //   filterable: "true",
      //   dicUrl: "/api/blade-system/dict-biz/dictionary?code=count_type",
      //   props: {
      //     label: "dictValue",
      //     value: "dictKey",
      //   },
      //   dataType: 'number',
      //   rules: [{
      //     required: true,
      //     message: "请选择计算类型",
      //     trigger: "blur",
      //   }, ],
      //   span: 22,
      // },
      {
        label: "方案名称",
        prop: "name",
        disabled: false,
        display: true,
        rules: [{
          required: true,
          message: "请输入内容",
          trigger: "blur",
        }, ],

        span: 24,
      },
      {
        label: "客户名称",
        placeholder: "请输入客户名称",
        formslot: true,
        prop: "custName",
        overHidden: true,
        display: true,
        span: 24,
        rules: [{
          required: true,
          message: "请选择",
          trigger: "blur",
        }, ],

      },
      // {
      //   label: "计算类型",
      //   prop: "calcType",
      //   type: "select",
      //   filterable: "true",
      //   dicUrl: "/api/blade-system/dict-biz/dictionary?code=count_type",
      //   props: {
      //     label: "dictValue",
      //     value: "dictKey",
      //   },
      //   dataType: 'number',
      //   display: true,
      //   rules: [{
      //     required: true,
      //     message: "请选择计算类型",
      //     trigger: "blur",
      //   }, ],
      //   span: 22,
      //   value: 2
      // }, 
      
      // {
      //   label: "所属部门",
      //   placeholder: "回显",
      //   prop: "managerDeptName",
      //   width: "150",
      //   disabled: true,
      //   display: true,
      //   click: () => {
      //     selectDeptClick();
      //   },
      //   span: 22,

      // }, {
      //   label: "业务经理",
      //   placeholder: "回显",
      //   width: "120",
      //   prop: "managerUserName",
      //   disabled: true,
      //   display: true,
      //   click: () => {
      //     selectPersonClick();
      //   },
      //   span: 22,
      // },
      // {
      //   label: "业务类型",
      //   prop: "bizType",
      //   type: "select",
      //   filterable: "true",
      //   dicUrl: "/api/blade-system/dict-biz/dictionary?code=biz_type",
      //   props: {
      //     label: "dictValue",
      //     value: "dictKey",
      //   },
      //   dataType: 'number',
      //   disabled: false,
      //   display: true,
      //   rules: [{
      //     required: true,
      //     message: "请选择业务类型",
      //     trigger: "blur",
      //   }, ],
      //   span: 22,
      // }, 
      {
        label: "融资额度",
        prop: 'quotationPrice',
        disabled: false,
        dataType: 'number',
        display: true,
        append: '元',
        rules: [{
          required: true,
          message: "请输入保理额度",
          trigger: "blur"
        }, ],
        precision: 2,
        span: 24,
      }, 
      // {
      //   label: "首付款",
      //   prop: 'downPayment',
      //   disabled: false,
      //   display: true,
      //   formslot: true,
      //   span: 22
      // }, {
      //   label: "首付款收取方式",
      //   prop: "downPaymentCollectWay",
      //   type: "select",
      //   filterable: "true",
      //   display: true,
      //   dicUrl: "/api/blade-system/dict-biz/dictionary?code=fee_collection_method",
      //   props: {
      //     label: "dictValue",
      //     value: "dictKey",
      //   },
      //   disabled: false,
      //   span: 22,
      // },
      // {
      //   label: "租金计算方式",
      //   formslot: true,
      //   prop: "calculateRentMethod",
      //   overHidden: true,
      //   display: true,
      //   span: 24,
      //   value: 1,
      //   disabled: false,
      //   rules: [{
      //     required: true,
      //     message: "请选择",
      //     trigger: "blur",
      //   }, ],
      // },

      // ---  保理业务
      // {
      //   label: "首付款使用费率",
      //   prop: 'purchasePrice1',
      //   append: '%',
      //   rules: [{
      //     required: true,
      //     message: "请输入",
      //     trigger: "blur"
      //   }, ],
      //   span: 22,
      // },
      {
        label: "是否申请宽限期",
        prop: "graceFlag",
        type: "select",
        filterable: "true",
        display: true,
        dicUrl: "/api/blade-system/dict-biz/dictionary?code=is_grace_period",
        props: {
          label: "dictValue",
          value: "dictKey",
        },
        dataType: 'number',
        rules: [{
          required: true,
          message: "请选择",
          trigger: "blur",
        }, ],
        span: 24,
      },
      {
        label: "宽限期费率",
        prop: 'graceInterestRate',
        append: '%',
        display: true,
        rules: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }, ],
        span: 13,
        labelWidth:130
      },
      {
        label: "宽限期",
        prop: 'gracePeriodDay',
        append: '天',
        display: true,
        rules: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }, ],
        span: 11,
        labelWidth:90
      },
      {
        label: "逾期使用费率",
        prop: 'overdueInterestRate',
        display: true,
        append: '%',
        rules: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }, ],
        span: 13,
        labelWidth:130
      },
      // ----
      // {
      //   label: "利息税率",
      //   formslot: true,
      //   disabled: false,

      //   prop: "interestTaxRate",
      //   overHidden: true,
      //   display: true,
      //   span: 24,

      // }, 
      // {
      //   label: "名义货价",
      //   prop: 'purchasePrice',
      //   formslot: true,
      //   display: true,
      //   disabled: false,
      //   span: 24,
      //   rules: [{
      //     required: true,
      //     message: "请选择",
      //     trigger: "blur",
      //   }, ],
      // }, {
      //   label: "如企业正常还款按此金额收取",
      //   prop: 'purchasePrice1',
      //   append: '元',
      //   disabled: false,
      //   display: true,
      //   rules: [{
      //     required: true,
      //     message: "请输入金额",
      //     trigger: "blur"
      //   }, ],
      //   span: 24,
      // },
       {
        label: "还款期限",
        prop: 'leaseTerm',
        append: '天',
        disabled: false,
        display: true,
        rules: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }, ],
        span: 11,
        labelWidth:90
      },
      // {
      //   label: "租金还款频次",
      //   formslot: true,
      //   prop: "repaymentFrequency",
      //   overHidden: true,
      //   display: true,
      //   disabled: false,
      //   span: 24,
      //   rules: [{
      //     required: true,
      //     message: "请选择",
      //     trigger: "blur",
      //   }, ],
      //   readonly: true,
      //   value: 1

      // }, 
      // {
      //   label: "租金偿还方式",
      //   formslot: true,
      //   prop: "paymentType",
      //   overHidden: true,
      //   display: true,
      //   disabled: false,
      //   span: 24,
      //   rules: [{
      //     required: true,
      //     message: "请选择",
      //     trigger: "blur",
      //   }, ],

      // },
       {
        label: "预计起息日",
        prop: "anticipatedValueDate",
        formslot: true,
        type: "date",
        disabled: false,
        display: true,
        format: "yyyy-MM-dd",
        valueFormat: "yyyyMMdd",
        span: 24,
        rules: [{
          required: true,
          message: "请选择",
          trigger: "blur",
        }, ],
      },
      // {
      //   label: "融资期限",
      //   prop: 'xxx',
      //   append: '月',
      //   rules: [{
      //     required: true,
      //     message: "请输入",
      //     trigger: "blur"
      //   }, ],
      //   span: 22,
      // },

      //  {
      //   label: "首次租金日",
      //   prop: "rentValueDate",

      //   type: "date",
      //   format: "yyyy-MM-dd",
      //   valueFormat: "yyyyMMdd",
      //   span: 22,

      // },
      {
        label: "首次还款日",
        prop: "rentValueDate",
        disabled: false,
        display: true,
        type: "date",
        format: "yyyy-MM-dd",
        valueFormat: "yyyyMMdd",
        span: 24,

      },

      // {
      //   label: "还款频次",
      //   formslot: true,
      //   prop: "repaymentFrequencyBl",
      //   overHidden: true,
      //   display: true,
      //   span: 22,
      //   rules: [{
      //     required: true,
      //     message: "请选择",
      //     trigger: "blur",
      //   }, ],
      //   value: 1,

      // },
      {
        label: "还款频次",
        formslot: true,
        prop: "repaymentFrequency",
        overHidden: true,
        display: true,
        span: 22,
        rules: [{
          required: true,
          message: "请选择",
          trigger: "blur",
        }, ],
        value:1,

      },

      // {
      //   label: "首月归还本金",
      //   prop: 'yyyyy',
      //   append: '元',
      //   rules: [{
      //     required: true,
      //     message: "请输入",
      //     trigger: "blur"
      //   }, ],
      //   span: 22,
      // },
      //  {
      //   label: "利率模式",
      //   formslot: true,
      //   prop: "interestRateModel",
      //   overHidden: true,
      //   display: true,
      //   disabled:false,
      //   span: 22,
      //   value: 2,
      //   rules: [{
      //     required: true,
      //     message: "请选择",
      //     trigger: "blur",
      //   }, ],
      // }, 
      // {
      //   label: "基准利率",
      //   formslot: true,
      //   prop: "benchmarkInterestRateName",
      //   overHidden: true,
      //   display: true,
      //   disabled:false,
      //   span: 22,
      //   rules: [{
      //     required: true,
      //     message: "请选择",
      //     trigger: "blur",
      //   }, ],

      // }, {
      //   label: "浮动方式",
      //   formslot: true,
      //   prop: "floatingMode",
      //   overHidden: true,
      //   display: true,
      //   disabled:false,
      //   span: 22,
      //   rules: [{
      //     required: true,
      //     message: "请选择",
      //     trigger: "blur"
      //   }, ],

      // }, {
      //   label: "浮动幅度",
      //   prop: "floatingRange",
      //   overHidden: true,
      //   display: true,
      //   disabled:false,
      //   span: 22,
      //   placeholder: "请输入比例",
      //   append: '%',

      // }, {
      //   label: "浮动基点",
      //   prop: "floatingPoint",
      //   overHidden: true,
      //   display: true,
      //   disabled:false,
      //   span: 22,
      //   placeholder: "请输入金额",
      //   append: 'bp',

      // }, {
      //   label: "利率调整方式",
      //   formslot: true,
      //   prop: "interestAdjustmentMode",
      //   overHidden: true,
      //   display: true,
      //   disabled:false,
      //   span: 22,
      //   rules: [{
      //     required: true,
      //     message: "请选择",
      //     trigger: "blur",
      //   }, ],

      // },
      {
        label: "首付款使用费率",
        prop: "annualInterestRate",
        overHidden: true,
        display: true,
        disabled: false,
        span: 24,
        placeholder: "请输入比例",
        append: '%',
        rules: [{
          required: true,
          message: "请选择",
          trigger: "blur",
        }, ],
      }
    ]
  }
}

export function calculateOption() {
  return {
    border: false,
    emptyBtn: false,
    submitBtn: false,
    column: [{
        label: "保理首付款及保理首付款使用费总额",
        prop: 'totalRentIncludeDownpayment',
        disabled: true,
        placeholder: '',
        append: '元',

      },
      {
        label: "保理首付款",
        prop: 'quotationPrice',
        disabled: true,
        placeholder: '',
        append: '元',

      }, {
        label: "租息总额",
        prop: 'totalInterest',
        disabled: true,
        placeholder: '',
        append: '元',

      }, 
      // {
      //   label: "TCR",
      //   prop: 'tcrStr',
      //   disabled: true,
      //   placeholder: '',
      //   append: '%',

      // },
       {
        label: "XIRR",
        prop: 'xirrStr',
        disabled: true,
        placeholder: '',
        append: '%',

      }
    ]
  }
}

export function tableConfig() {
  return {
    menuType: "button",
    addBtn: false,
    menuWidth: 50,
    menuAlign: "center",
    card: true,
    menu: false,
    delBtn: false,
    editBtn: false,
    align: "center",
    searchMenuSpan: 8,
    columnBtn: false,
    searchBtn: true,
    // index: true,
    // indexLabel: "期数",
    refreshBtn: false,
    showSummary: true,
    sumColumnList: [{
        name: "expectedRent",
        overHidden: true,
        type: "sum",
      },
      {
        name: "principal",
        overHidden: true,
        type: "sum",
      },
      {
        name: "interest",
        overHidden: true,
        type: "sum",
      },
      {
        name: "cashFlow",
        overHidden: true,
        type: "sum",
      }
    ],
    column: [{
        label: "期数",
        prop: "issue",
        overHidden: true,
        display: false,
        width: 50,

      },
      // {
      //   label: "租金日",
      //   fixed: true,
      //   prop: "rentDay",
      //   overHidden: true,
      //   display: false,
      //   slot: true,

      // },
      {
        label: "还款日",
        prop: "rentDay",
        overHidden: true,
        display: false,
        slot: true,
        dataType: 'string'


      },
      {
        label: "每期保理首付款及保理首付款使用费合计额",
        prop: "expectedRent",
        // slot: true,
        formatter: (row, value, label, column) => {
          return Number(value).toFixed(2)
        },
        overHidden: true,
      },

      {
        label: "每期保理首付款",
        prop: "principal",
        slot: true,
        formatter: (row, value, label, column) => {
          return Number(value).toFixed(2)
        },
        overHidden: true,
      },

      {
        label: "每期保理首付款使用费",
        prop: "interest",
        // slot: true,
        formatter: (row, value, label, column) => {
          return Number(value).toFixed(2)
        },
        overHidden: true,
      },

      {
        label: "剩余保理首付款",
        prop: "residualPrincipal",
        // slot: true,
        formatter: (row, value, label, column) => {
          return Number(value).toFixed(2)
        },
        overHidden: true,
      },

      {
        label: "现金流量",
        prop: "cashFlow",
        // slot: true,
        formatter: (row, value, label, column) => {
          return Number(value).toFixed(2)
        },
        overHidden: true,
      },
      {
        label: "操作",
        prop: "menuLabel",
        slot: true,
        hide: true,
        overHidden: true,
      }

    ]
  }
}
